import { Injectable } from '@angular/core';
// import Uppy from 'uppy/lib/core'
// import Dashboard from 'uppy/lib/plugins/Dashboard'
// import Tus10 from 'uppy/lib/plugins/Tus10'
// import Informer from 'uppy/lib/plugins/Informer'
// import MetaData from 'uppy/lib/plugins/MetaData'
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class FileUploadService {
  // apikey = 'ADBfjNuMLQH2NORCI4WAmz'; // expired
  apiKey = 'Aan6wd2btQsylqrEpvWcJz';
  client = filestack.init(this.apiKey);
  // uppy: any;

  constructor(private http: HttpClient) {
    // this.uppy = Uppy({ autoProceed: false })
    //   .use(Dashboard, { trigger: '#uploadFile' })
    //   .use(Informer, { target: Dashboard })
    //   .use(Tus10, { endpoint: '://master.tus.io/files/' })
    //   .use(MetaData, {
    //     fields: [
    //       { id: 'resizeTo', name: 'Resize to', value: 1200, placeholder: 'specify future image size' },
    //       { id: 'description', name: 'Description', value: 'none', placeholder: 'describe what the file is for' }
    //     ]
    //   })
    // // .run()
  }

  showPicker() {
    return this.client.pick({})
  }

  // getFileUploadRef() {
  //   return this.uppy;
  // }

}
